import type { Dispatch, SetStateAction } from 'react'

type LoadingSetter = Dispatch<SetStateAction<boolean>>

type RunAsyncActionParams<TResult> = {
  action: () => Promise<TResult>
  fallbackErrorMessage: string
  setLoading?: LoadingSetter
  onErrorMessage?: (message: string) => void
}

export const toAsyncActionErrorMessage = (error: unknown, fallbackErrorMessage: string): string => {
  if (error instanceof Error && error.message.trim()) {
    return error.message
  }
  return fallbackErrorMessage
}

export const runAsyncAction = async <TResult>({
  action,
  fallbackErrorMessage,
  setLoading,
  onErrorMessage,
}: RunAsyncActionParams<TResult>): Promise<TResult | null> => {
  setLoading?.(true)
  try {
    return await action()
  } catch (error) {
    onErrorMessage?.(toAsyncActionErrorMessage(error, fallbackErrorMessage))
    return null
  } finally {
    setLoading?.(false)
  }
}
